import './DialogBox.scss'

import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import React from 'react'
import { lennarTheme } from 'src/lennarTheme'

interface DialogBoxProps {
  modalType?: string
  onActionClick: (isSubmit?: boolean) => void
  onClose: () => void
  onIconClose?: () => void
  open: boolean
}

export const DialogBox: React.FC<DialogBoxProps> = ({
  modalType,
  onActionClick,
  onClose,
  onIconClose,
  open,
}) => {
  return (
    <Dialog open={open}>
      <DialogTitle
        className="draft-modal-title"
        sx={{
          color: '#1c2b36',
          fontSize: '20px',
          fontWeight: 700,
          lineHeight: '28px',
        }}
      >
        {modalType === 'Draft Dialog' && 'Save to drafts?'}
        {modalType === 'Back Button Dialog' && 'Leave this page?'}
        {modalType === 'Submit Button Dialog' && 'Unsaved Changes'}
        <IconButton
          edge="end"
          color="inherit"
          onClick={onIconClose}
          aria-label="close"
          sx={{
            color: '#1c2b36',
            position: 'absolute',
            right: 14,
            top: 10,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="draft-modal-content">
        {modalType === 'Draft Dialog' && (
          <Typography>
            You can save the file to drafts and continue working on it later
          </Typography>
        )}
        {modalType === 'Back Button Submit Dialog' && (
          <Typography>
            Leaving this page will result in loss of data. Would you like to
            save the changes?
          </Typography>
        )}

        {modalType === 'Back Button Dialog' && (
          <Typography>
            Leaving this page will result in loss of data. Would you like to
            save your progress as a draft?
          </Typography>
        )}
        {modalType === 'Submit Button Dialog' && (
          <Typography>
            Would you like to save the changes and submit?
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={onClose}
          className="button-cancel"
          sx={{
            color: lennarTheme?.lennarDesignSystem?.lennarBlues?.lennarBlue,
            fontSize: '12px',
            fontWeight: 700,
            textAlign: 'center',
            textTransform: 'capitalize',
          }}
        >
          {modalType === 'Draft Dialog' && 'Cancel'}
          {(modalType === 'Back Button Dialog' ||
            modalType === 'Back Button Submit Dialog') &&
            'Leave the page'}
          {modalType === 'Submit Button Dialog' && 'No'}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            onActionClick(modalType === 'Back Button Submit Dialog')
          }
          className="button-save-as-draft"
          sx={{
            background:
              lennarTheme?.lennarDesignSystem?.lennarBlues?.lennarBlue,
            fontSize: '12px',
            fontWeight: 700,
            textAlign: 'center',
            textTransform: 'capitalize',
          }}
        >
          {(modalType === 'Back Button Dialog' ||
            modalType === 'Draft Dialog') &&
            'Save As Draft'}
          {modalType === 'Back Button Submit Dialog' && 'Submit'}
          {modalType === 'Submit Button Dialog' && 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
